export default "__VITE_ASSET__CXqLgJsM__"